import React, { useState, useContext } from 'react';
import axios from 'axios';
import { AuthContext } from "./../../Contextapi/ContextApi";
import { baseUrl } from "./../../Apiurls/Apiurls";
import Navbar from "../../Shared/Navbar";

const ChangePassword = () => {
    const { userId } = useContext(AuthContext);
    const [formData, setFormData] = useState({
        newPassword: '',
        confirmPassword: ''
    });
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [messageType, setMessageType] = useState(''); // 'success' or 'error'

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        // Validation
        if (formData.newPassword !== formData.confirmPassword) {
            setMessage('New password and confirm password do not match');
            setMessageType('error');
            return;
        }

        if (formData.newPassword.length < 6) {
            setMessage('New password must be at least 6 characters long');
            setMessageType('error');
            return;
        }

        setLoading(true);
        setMessage('');

        try {
            const response = await axios.put(`${baseUrl}/change-password`, {
                userId: userId,
                newPassword: formData.newPassword
            });

            if (response.data.success) {
                setMessage('Password changed successfully!');
                setMessageType('success');
                setFormData({
                    newPassword: '',
                    confirmPassword: ''
                });
            } else {
                setMessage(response.data.message || 'Failed to change password');
                setMessageType('error');
            }
        } catch (error) {
            console.error('Password change error:', error);
            setMessage(
                error.response?.data?.message || 
                'Error changing password. Please try again.'
            );
            setMessageType('error');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-md-2">
                    <Navbar />
                </div>

                <div className="col-md-10">
                    <div className="container" style={{ marginTop: "100px" }}>
                        <div className="row justify-content-center">
                            <div className="col-md-6">
                                <div className="card shadow">
                                    <div className="card-header bg-primary text-white">
                                        <h4 className="mb-0">Change Password</h4>
                                    </div>
                                    <div className="card-body">
                                        {message && (
                                            <div 
                                                className={`alert ${
                                                    messageType === 'success' 
                                                        ? 'alert-success' 
                                                        : 'alert-danger'
                                                }`}
                                            >
                                                {message}
                                            </div>
                                        )}

                                        <form onSubmit={handleSubmit}>
                                            <div className="mb-3">
                                                <label htmlFor="newPassword" className="form-label">
                                                    New Password
                                                </label>
                                                <input
                                                    type="password"
                                                    className="form-control"
                                                    id="newPassword"
                                                    name="newPassword"
                                                    value={formData.newPassword}
                                                    onChange={handleChange}
                                                    required
                                                    disabled={loading}
                                                    minLength="6"
                                                    placeholder="Enter new password"
                                                />
                                                <div className="form-text">
                                                    Password must be at least 6 characters long.
                                                </div>
                                            </div>

                                            <div className="mb-4">
                                                <label htmlFor="confirmPassword" className="form-label">
                                                    Confirm New Password
                                                </label>
                                                <input
                                                    type="password"
                                                    className="form-control"
                                                    id="confirmPassword"
                                                    name="confirmPassword"
                                                    value={formData.confirmPassword}
                                                    onChange={handleChange}
                                                    required
                                                    disabled={loading}
                                                    placeholder="Confirm new password"
                                                />
                                            </div>

                                            <div className="d-grid">
                                                <button
                                                    type="submit"
                                                    className="btn btn-primary btn-lg"
                                                    disabled={loading}
                                                >
                                                    {loading ? (
                                                        <>
                                                            <span className="spinner-border spinner-border-sm me-2" />
                                                            Changing Password...
                                                        </>
                                                    ) : (
                                                        'Change Password'
                                                    )}
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ChangePassword;